<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
          <label class="mb-3"> <i  > List all class template except <b>"single class" </b>  </i>  </label>
          <multiselect v-model="form.class_template_id" placeholder="" :custom-label="a" 
          :options="listclass" label="text"  track-by="value" :multiple="true"></multiselect>

          </CCol> 
          </CRow>
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="assign_class(form.id, form.class_template_id)"  variant="outline" color="info">Update</CButton>
      </template>
      <!-- <pre>{{ $data  }}</pre> -->
    </CModal>
  </form>

</template>

<script>
import axios from 'axios'
import EventBus from '@/eventBus';
import Multiselect from 'vue-multiselect'
import classbatch from '@/services/batch'
import classtemplate from '@/services/class_template'

export default {
name: 'assignmodal',
components: { Multiselect},
  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      form:{
        id:'',
        class_template_id:[],
      },
      listclass:[],
    }
  },
  mounted (){
     this.load()

      EventBus.$on('PAGE_UPDATE', (data) => {
      if(data){
          this.load();
      }
    });
   },
   computed: {
        // filterArray: function() {
        //     var result =  this.listclass.filter((item) =>
        //         item.class_template_id.typ(this.search)
        //     );
           
        //     return result;
        // }
    },
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_ASSIGN_CLASS', (params) => {
      if(params.data){
        classbatch.getBatchbyID(params.data)
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.id = res.data.id;
          self.form.class_template_id = JSON.parse(res.data.class_template_id);
          }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.class_template_id  = "";
      }
    });
    this.form.id = this.$route.query.Pud
  },
   mounted (){
     this.loadData()
   },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    
    loadData() {
      classtemplate.getTemplate()
        .then(res => {
          for (let i=0; i <= res.data.length-1; i++){
            //alert
            this.listclass.push({text: res.data[i].name, value:res.data[i].id})
            
          }
          })

    },
    assign_class(id,class_template_id){
      
      this.show = false;
      if(confirm("Do you really want to assign class to this batch ?")){
                    var param = {
          class_template_id: JSON.stringify(class_template_id.map(item => item.value))
          }
                
          
          classbatch.assign_class(id,param)
          .then(res => {
            //this.load()
            EventBus.$emit('PAGE_UPDATE', true)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
        }
    },
    // load(){
    //  group.getGroupbyID(this.$route.query.Pud)
    //   .then(res => {
    //   this.datas =res
     
    //   })
    // },
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>